import create from './create';
import get from './get';
import del from './del';
import edit from './edit';
import countAll from './countAll';

export default {
  create,
  get,
  del,
  edit,
  countAll,
};



// WEBPACK FOOTER //
// ./src/services/wordboard/index.js